import React, { useEffect, useState } from 'react'
import utils from '../../utils'
import { HiReceiptRefund } from 'react-icons/hi'
import { FiCheckCircle } from 'react-icons/fi'
import { FaXmark } from 'react-icons/fa6'
import { useAuth } from '../../context/UserContext'
import adminServices from '../../services/AdminServices'
import vendorServices from '../../services/VendorSevices'
import paymentsService from '../../services/PaymentServices'

function RefundStats() {
    const { user } = useAuth()
    const [stats, setStats] = useState()

    useEffect(() => {
        getRefundStats(user);
    }, [user]);

    const getRefundStats = (user) => {
        let services;
        if (user?.is_admin) {
            services = adminServices;
        }
        if (user?.is_vendor) {
            services = vendorServices;
        }
        if (!user?.is_admin && !user?.is_vendor) {
            services = paymentsService
        }

        if (services && typeof services.refundsStats === 'function') {
            services.refundsStats().then(
                (res) => {
                    setStats(res.data);
                },
                (err) => {
                    console.log(err);
                }
            );
        }
    };
    return (
        <div>
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Total Refunds</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.refunds_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><HiReceiptRefund className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Resolved</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.resolved_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-red-100 rounded-full">
                            <span className="material-icons text-primary"><FiCheckCircle className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow">
                    <div className="flex items-start justify-between">
                        <div>
                            <p className="text-sm font-medium text-gray-500">Unresolved</p>
                            <p className="text-3xl font-bold text-gray-900 mt-2">{utils.toCommas(stats?.unresolved_count || 0)}</p>
                        </div>
                        <div className="p-2 bg-orange-100 rounded-full">
                            <span className="material-icons text-secondary"><FaXmark className='h-7 w-7' /></span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default RefundStats